module.exports = __webpack_public_path__ + "img/header-v2-community-login.6dc710c9.svg";